import React from "react";
// nodejs library that concatenates classes

// reactstrap components
import {
  Card,
  CardBody,
  Container,
  Row,
  Col, Modal, Form, Button,
} from "reactstrap";

// core components

// index page sections


import {getStats} from "../../components/helpers/StatsHelpers";
import {RiUser3Fill} from "react-icons/ri";
import withNavigateHook from "../../hooks/withNavigationHook";
import {useParams} from "react-router-dom";
import {confirmUserVerification} from "../../components/helpers/UserHelpers";
import {SeoHelper} from "../../components/helpers/SeoHelper";

class EmailConfirmationVerification extends React.Component {
  state = {
    songBookCount: null
  };

  constructor(props) {
    super(props);
    getStats.call(this);

    // createPaymentIntent("single_test", 500);

    // this.setState({songBookCount: songBookCount()});
  }

  componentDidMount() {
    const { id, code } = this.props.params;

    confirmUserVerification(id, code).then(result => {
      this.toggleModalAndMoveToHome("formModalComplete");
    })
  }

  toggleModalAndMoveToHome = (state) => {
    this.setState({
      [state]: !this.state[state],
    });
  };

  render() {
    return (
      <>
        <SeoHelper noindex={true} />

        {/*<main ref="main">*/}
          <div className="position-relative">
            {/* shape Hero */}
            <section className="section section-lg section-shaped pb-250">
              <div className="shape shape-style-1 shape-default">
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
              </div>
              <Container className="py-lg-md d-flex">
                <div className="col px-0">
                  <Row>
                    <Col lg="8">
                      <h1 className="display-3 text-white">
                        Building your song-flows{" "}
                        <span>email verification</span>
                      </h1>
                      {/*<p className="lead text-white">*/}
                      {/*  The design system comes with four pre-built pages to*/}
                      {/*  help you get started faster. You can change the text and*/}
                      {/*  images and you're good to go.*/}
                      {/*</p>*/}
                    </Col>
                  </Row>
                </div>
              </Container>
              {/* SVG separator */}
              <div className="separator separator-bottom separator-skew">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    preserveAspectRatio="none"
                    version="1.1"
                    viewBox="0 0 2560 100"
                    x="0"
                    y="0"
                >
                  <polygon
                      className="fill-white"
                      points="2560 0 2560 100 0 100"
                  />
                </svg>
              </div>
            </section>
            {/* 1st Hero Variation */}
          </div>
          <section className="section section-lg pt-lg-0 mt--200">
            <Container>
              <Row className="justify-content-center">
                <Col lg="12">
                  <Row className="row-grid">
                    <Col lg="12">
                      <Card className="card-lift--hover shadow border-0">
                        <CardBody className="py-5">
                          {/*<div className="icon icon-shape icon-shape-warning rounded-circle mb-4">*/}
                          {/*  <i className="ni ni-planet" />*/}
                          {/*</div>*/}
                          <Row>
                            <Col>
                              <h2 style={{fontSize: '1rem'}} className="text-primary text-uppercase">
                                <RiUser3Fill color='#5e72e4' size="36"/>&nbsp;Registration confirmation
                              </h2>
                              <p className="description mt-3">
                                Thank you.
                              </p>
                            </Col>
                          </Row>
                          <Modal
                              className="modal-dialog-centered"
                              size="sm"
                              isOpen={this.state.formModalComplete}
                              toggle={() => this.toggleModalAndMoveToHome("formModalComplete")}
                          >
                            <div className="modal-header">
                              <h2 style={{fontSize: '1rem'}} className="modal-title" id="modal-title-default">
                                Email address verification
                              </h2>
                              <button
                                  aria-label="Close"
                                  className="close"
                                  data-dismiss="modal"
                                  type="button"
                                  onClick={() => this.toggleModalAndMoveToHome("formModalComplete")}
                              >
                                <span aria-hidden={true}>×</span>
                              </button>
                            </div>
                            <div className="modal-body p-0">
                              <Card className="bg-secondary shadow border-0">
                                <CardBody className="px-lg-5 py-lg-5">
                                  <div className="text-center text-muted mb-4">
                                    You have successfully confirmed your email address.
                                    <br/>
                                    <br/>
                                    Thank you
                                  </div>
                                  <Form role="form">
                                    <div className="text-center">
                                      <Button
                                          className="my-4"
                                          color="primary"
                                          type="button"
                                          onClick={() => this.toggleModalAndMoveToHome("formModalComplete")}
                                      >
                                        <i className="fa fa-share-alt" aria-hidden="true"></i>
                                        <span className="btn-inner--text">Close</span>
                                      </Button>
                                    </div>
                                  </Form>
                                </CardBody>
                              </Card>
                            </div>
                          </Modal>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Container>
          </section>
        {/*</main>*/}
        
      </>
    );
  }
}

export default withNavigateHook((props) => (
    <EmailConfirmationVerification{...props} params={useParams()} />
));
